"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Icon_1 = require("../Icon");
const LazyImage_1 = require("../LazyImage");
const useScaleFactor_1 = require("../../utils/hooks/useScaleFactor");
// styles
require("./avatar.scss");
// use the optional prop interface to define the default props
const defaultProps = {
    size: "medium",
    "data-testid": "tecma-avatar",
    alt: "tecma-avatar-alternative",
};
const Avatar = (_a) => {
    var { size, className, src, text, alt, icon } = _a, rest = __rest(_a, ["size", "className", "src", "text", "alt", "icon"]);
    const classList = (0, classnames_1.default)("tecma-avatar", { [`${size}`]: size }, className);
    let childrenToRender;
    const avatarNodeRef = (0, react_1.useRef)(null);
    const avatarChildrenRef = (0, react_1.useRef)(null);
    const childrenScale = (0, useScaleFactor_1.useScaleFactor)(avatarNodeRef, avatarChildrenRef, 4, [text]);
    const imgExist = !!src;
    const iconNameExist = !!icon;
    const textExist = !!text;
    const transformString = childrenScale ? `scale(${childrenScale})` : "";
    if (imgExist) {
        childrenToRender = (0, jsx_runtime_1.jsx)(LazyImage_1.LazyImage.Image, { src: src, alt: alt });
    }
    else if (iconNameExist) {
        childrenToRender = (0, jsx_runtime_1.jsx)(Icon_1.Icon, { className: "avatar-icon", iconName: icon, size: size });
    }
    else if (textExist) {
        childrenToRender = ((0, jsx_runtime_1.jsx)("span", Object.assign({ ref: avatarChildrenRef, style: {
                msTransform: transformString,
                WebkitTransform: transformString,
                transform: transformString,
            } }, { children: text })));
    }
    else {
        childrenToRender = (0, jsx_runtime_1.jsx)("span", {});
    }
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ ref: avatarNodeRef, className: classList }, rest, { children: childrenToRender })));
};
Avatar.defaultProps = defaultProps;
exports.default = react_1.default.memo(Avatar);
